import { Injectable } from '@angular/core';
import { HttpRequestType } from 'src/app/core/request.service';
import { Constants, SearchOperations } from '../../../app.constants';
import { BaseService } from '../../../shared/base/base.service';
import { OfferedProduct } from '../offered-products/offered-products.models';
import { AttributeSelection, ProductCatalogueItem } from './product-catalogues.models';

@Injectable({
  providedIn: 'root'
})
export class ProductCatalogueItemsService extends BaseService {
  url: string = `${Constants.contextPath}/product-catalogue-items`;
  
  addItem(item: ProductCatalogueItem, productCatalogueId: string, onSuccess: Function) {
    this.create(this.url, this.modifyItemBeforeUpdate(JSON.parse(JSON.stringify(item)), productCatalogueId), (response) => {
      onSuccess(response);
    })
  }

  addMultipleItems(items: ProductCatalogueItem[] = [], productCatalogueId: string, onSuccess: Function) {
    items.map(item => this.modifyItemBeforeUpdate(JSON.parse(JSON.stringify(item)), productCatalogueId));
    this.create(`${this.url}/list`, items, (response) => {
      onSuccess(response);
    })
  }

  editItem(item: ProductCatalogueItem, onSuccess: Function) {
    this.update(this.url, this.modifyItemBeforeUpdate(item), (response) => {
      onSuccess(response);
    })
  }

  deleteItem(id: string, onSuccess: Function) {
    this.delete(this.url, id, (response) => {
      onSuccess(response);
    })
  }

  addItemsByPointOfSale(data: AttributeSelection, onSuccess: Function) {
    this.requestService.createRequest(HttpRequestType.Put, `${this.url}/add-items-by-point-of-sale`, data, null, (response) => {
      onSuccess(response);
    })
  }

  addItemsByAttribute(data: AttributeSelection, onSuccess: Function) {
    this.requestService.createRequest(HttpRequestType.Put, `${this.url}/add-items-by-attribute`, data, null, (response) => {
      onSuccess(response);
    })
  }

  deleteAllItems(productCatalogueId: string, onSuccess: Function) {
    let filter = `?${SearchOperations.KEY_SEARCH}=${SearchOperations.LEFT_PARENTHESES_READABLE}productCatalogue${SearchOperations.SPLIT_JOIN_OPERATOR}id${SearchOperations.EQUALITY}${productCatalogueId}${SearchOperations.RIGHT_PARENTHESES_READABLE}`;
    this.requestService.createRequest(HttpRequestType.Delete, `${this.url}${filter}`, null, null, (response) => {
      onSuccess(response);
    })
  }

  deleteSelectedItems(selectedItems: string[] = [], onSuccess: Function) {
    let filter = `?${SearchOperations.KEY_SEARCH}=${SearchOperations.LEFT_PARENTHESES_READABLE}id${SearchOperations.IN}${selectedItems.join(SearchOperations.SPLIT_JOIN_OPERATOR)}${SearchOperations.RIGHT_PARENTHESES_READABLE}`;
    this.requestService.createRequest(HttpRequestType.Delete, `${this.url}${filter}`, null, null, (response) => {
      onSuccess(response);
    })
  }

  deactivateItems(items: string[] = [], onSuccess: Function) {
    this.requestService.createRequest(HttpRequestType.Patch, `${this.url}/deactivate`, items, null, (response) => {
      onSuccess(response);
    })
  }

  modifyItemBeforeUpdate(item: ProductCatalogueItem, productCatalogueId?: string) {
    if(item.offeredProduct && typeof item.offeredProduct == 'object' && item.offeredProduct.id) {
      item.offeredProduct = (<OfferedProduct>item.offeredProduct).id
    }
    if(productCatalogueId)
      item.productCatalogue = productCatalogueId;
    return item;
  }

  getListByProductCatalogueId(productCatalogueId: string,onSuccess: Function) {
    let filter = `?${SearchOperations.KEY_SEARCH}=${SearchOperations.LEFT_PARENTHESES_READABLE}productCatalogue${SearchOperations.SPLIT_JOIN_OPERATOR}id${SearchOperations.EQUALITY}${productCatalogueId}${SearchOperations.RIGHT_PARENTHESES_READABLE}`;
    return this.requestService.createRequest(HttpRequestType.Get, `${this.url}/list${filter}`, null, null, (response) => {
      onSuccess(response);
    })
  }
}
